import { render, staticRenderFns } from "./RestaurantCard.vue?vue&type=template&id=b211b77e&scoped=true&"
import script from "./RestaurantCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantCard.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCard.vue?vue&type=style&index=0&id=b211b77e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b211b77e",
  null
  
)

export default component.exports